import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './views/HomeView.vue';
import ServicosView from './views/ServicosView.vue';
import ClientesView from './views/ClientesView.vue';
import SobreNosView from './views/SobreNosView.vue';
import SolucoesView from './views/SolucoesView.vue';
import SolucaoView from './views/SolucaoView.vue';
import ContactosView from './views/ContactosView.vue';
import ConteudoGeralView from './views/ConteudoGeralView.vue';
import ConteudoGeralTemaView from './views/ConteudoGeralTemaView.vue';
import NoticiaView from './views/NoticiaView.vue';


let base = '/';
// let base = '/testes/ibase/';

export const router = createRouter({
  history: createWebHistory(),
  base: base,
  scrollBehavior(to, from, savedPosition) {
    return { left: 0, top: 0 };
  },
  routes: [
    {
      path: base,
      name: 'home',
      component: HomeView,
    },
    {
      path: base + 'solucoes',
      name: 'solucoes',
      component: SolucoesView,
    },
    {
      path: base + 'solucao/:id',
      name: 'solucao',
      component: SolucaoView,
    },
    {
      path: base + 'servicos',
      name: 'servicos',
      component: ServicosView,
    },
    {
      path: base + 'clientes',
      name: 'clientes',
      component: ClientesView,
    },
    {
      path: base + 'sobreNos',
      name: 'sobreNos',
      component: SobreNosView,
    },
    {
      path: base + 'contactos',
      name: 'contactos',
      component: ContactosView,
    },
    {
      path: base + 'termosCondicoes',
      name: 'termosCondicoes',
      component: ConteudoGeralView,
    },
    {
      path: base + 'politicaDePrivacidade',
      name: 'politicaDePrivacidade',
      component: ConteudoGeralView,
    },
    {
      path: base + 'politicaDePrivacidade/:id',
      name: 'conteudoGeralTema',
      component: ConteudoGeralTemaView,
    },
    {
      path: base + 'politicaDeCookies',
      name: 'politicaDeCookies',
      component: ConteudoGeralView,
    },
    {
      path: base + 'noticia/:id',
      name: 'noticia',
      component: NoticiaView,
    },
    {
      path: base + ':pathMatch(.*)*',
      name: 'notFound',
      component: HomeView,
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'noMatch',
      component: HomeView,
    },
  ],
});
